var render, staticRenderFns
import script from "./ib-button-back.vue?vue&type=script&lang=js&"
export * from "./ib-button-back.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ib-button-back.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/dev39a/aleggett/thgit/web.app/lib.common/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('058f4f0b')) {
      api.createRecord('058f4f0b', component.options)
    } else {
      api.reload('058f4f0b', component.options)
    }
    
  }
}
component.options.__file = "src/components/button/ib-button-back.vue"
export default component.exports